import { render, staticRenderFns } from "./PlaceParent.vue?vue&type=template&id=7960a562&scoped=true&"
import script from "./PlaceParent.vue?vue&type=script&lang=js&"
export * from "./PlaceParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960a562",
  null
  
)

export default component.exports